import { render, staticRenderFns } from "./TaxableDeterminationTypeField.vue?vue&type=template&id=18e04b65"
import script from "./TaxableDeterminationTypeField.vue?vue&type=script&lang=js"
export * from "./TaxableDeterminationTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports